import { Link } from 'react-router-dom';
import { DESTINATIONS } from '../../data/landing';

/**
 * Destinations marquee — a signature, oversized typographic band. Indian city
 * names scroll continuously (paused on hover), alternating filled and outlined
 * display type for editorial contrast. Each links to /search?destination=<city>
 * (frozen contract). Honors reduced-motion via the CSS in index.css.
 */
export function DestinationMarquee() {
  // Duplicate the list so the -50% keyframe loops seamlessly.
  const loop = [...DESTINATIONS, ...DESTINATIONS];

  return (
    <section aria-label="Popular destinations" className="grain relative overflow-hidden bg-ink py-6">
      <p className="mb-4 px-6 text-center text-xs font-semibold uppercase tracking-[0.25em] text-cream/45 sm:px-10">
        Where our hotels are
      </p>
      <div className="marquee-track">
        {loop.map((city, i) => (
          <Link
            key={`${city}-${i}`}
            to={`/search?destination=${encodeURIComponent(city)}`}
            className="group flex items-center"
            aria-label={`Explore hotels in ${city}`}
          >
            <span
              className={`px-5 font-serif text-2xl font-black uppercase tracking-tight transition-colors duration-300 sm:px-6 sm:text-3xl ${
                i % 2 === 0
                  ? 'text-cream group-hover:text-clay'
                  : 'text-stroke-cream group-hover:text-clay'
              }`}
            >
              {city}
            </span>
            <span className="text-lg text-clay sm:text-xl" aria-hidden="true">✦</span>
          </Link>
        ))}
      </div>
    </section>
  );
}
